module.exports = __webpack_public_path__ + "static/media/pikto_trimino.d63b82b1.png";